export default [
  {
    name: 'earth',
    type: 'texture',
    path: `${php_vars.themeDirUrl}/assets/img/globe/earth.jpg`,
  },
  {
    name: 'earthBump',
    type: 'texture',
    path: `${php_vars.themeDirUrl}/assets/img/globe/bump.jpg`,
  },
]
